<template>
  <div>
    <div v-for="(type, typeIndex) in roomTypeList" :key="typeIndex">
      <div style="border-top:solid 12px #F9FAFB;" class="roomType">
        <el-row style="display: flex;">
          <el-col :span="7" style="background-color: #f2f2f2;padding: 8px 0px;">
            <el-row>
              <div style="display: flex; align-items: stretch;line-height: 1.8;margin-bottom: 4px; cursor: pointer" @click="type.isViewMore = !type.isViewMore">
                <el-col :span="8">
                  <div>
                    <img v-if="type.image" :src="type.image" :alt="`${type.title}照片`" style="width: 91px;height: 70px; object-fit: cover; border-radius: 8px;" />
                    <img v-else src="@assets/images/default_room.jpg" alt="預設房型圖片" style="width: 91px;height: 70px; object-fit: cover; border-radius: 8px;" />
                  </div>
                  <el-popover placement="right-start" trigger="click" width="160" popper-class="settings-menu-popper">
                    <div style="display: flex; flex-direction: column; gap: 10px; padding: 5px 0;">
                      <el-popover placement="right-start" trigger="click" width="450" @click.stop>
                        <el-button slot="reference" round size="small" @click.stop style="width: 100%; margin-left: 0;">
                          查看可入住種類
                        </el-button>

                        <div style="max-height: 250px; overflow-y: auto; width:auto;">
                          <div style="font-weight: bold; margin-bottom: 8px; border-bottom: 1px solid #eee; padding-bottom: 4px;position:fixed;background-color: #ffffff;width:420px">
                            所有可入住種類 (共 {{ type.categories.length }} 項)
                          </div>
                          <div style="margin-top:28px">
                            <div v-for="(item, index) in type.categories" :key="index" style="padding: 8px 0; font-size: 14px; border-bottom: 1px dashed #f0f0f0; ">
                              {{ item.title }}
                            </div>
                          </div>
                        </div>
                      </el-popover>
                      <el-button type="primary" round size="medium" @click.stop="$router.push(`/hotel/modify-room/${type.id}`)" style="width: 100%; margin-left: 0;">
                        房型設定
                      </el-button>
                      <el-button type="primary" round size="medium" @click.stop="$router.push(`/hotel/room-scheduling/${type.id}`)" style="width: 100%; margin-left: 0;">
                        房況管理
                      </el-button>
                    </div>

                    <el-button slot="reference" type="text" icon="el-icon-setting" @click.stop style="font-size: 28px;  padding-right: 40px;"> </el-button>
                  </el-popover>
                </el-col>
                <el-col :span="14" style=" text-align: left;margin-left: 4px; color:#6C6B6B">
                  <div>
                    <div style="font-weight: bold; color:#121931; font-size:16px;">
                      {{ type.title }}
                      <span style="font-size: 12px; color: #6C6B6B"> | {{ type.rooms.length }}間 </span>
                    </div>
                    <div> 可入住數：1~{{ type.accommodates }}</div>
                  </div>

                  <div>
                    <div v-for="(item, index) in type.categories.slice(0, 3)" :key="`Category-${index}`">
                      {{ item.title }}
                    </div>
                  </div>
                </el-col>
                <el-col :span="1" style="display: flex; align-items: center;">
                  <template>
                    <font-awesome-icon
                      :icon="['far', 'chevron-down']"
                      :style="{
                        color: '#ea6a2a',
                        fontSize: '16px',
                        transition: 'transform 0.6s ease',
                        transform: type.isViewMore ? 'rotate(180deg)' : 'rotate(0deg)',
                      }"
                    />
                  </template>
                </el-col>
              </div>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-button @click="$router.push(`/hotel/modify-room/${type.id}`)" style="width:90%;border-radius: 8px;">房型設定</el-button>
              </el-col>
              <el-col :span="12">
                <el-button @click="$router.push(`/hotel/room-scheduling/${type.id}`)" style="width:90%;border-radius: 8px;">房況管理</el-button>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="17" style="padding: 0px; display: flex; flex-direction: column;">
            <el-row style="flex: 1; display: flex; flex-wrap: wrap;">
              <el-col
                v-for="(defaultPrice, defaultPriceIndex) in type.defaultPrices"
                :key="defaultPriceIndex"
                :span="3"
                style="
                                border:solid 1px #0000000F;
                                margin:0px 6px;
                                background-color: #ffffff;
                                display: flex;
                                align-items: center;
                                justify-content: center;

                            "
              >
                NT${{ formatNumber(defaultPrice) }}
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <!-- 跑每個房型的房間數迴圈 -->
        <el-row v-show="type.isViewMore" v-for="(room, roomIndex) in type.rooms" :key="roomIndex" class="room" :class="type.isViewMore ? 'fade-in' : 'fade-out'">
          <el-col :span="7" style="background-color: #ffffff;">
            <div style="display: flex; justify-content: space-around;align-items: center;">
              <div style="font-weight: 400; color:#000000">{{ room.roomTitle }}</div>
              <el-button type="text" color="#626aef" @click="$router.push(`/hotel/subroom-scheduling/${room.roomId}`)"> <i class="fal fa-edit fa-md"></i>房況管理 </el-button>
            </div>
          </el-col>
          <el-col :span="17" style="padding: 0px;">
            <el-row>
              <el-col
                v-for="(dateRoom, dateRoomIndex) in room.availabilityByDate"
                :key="dateRoomIndex"
                :span="3"
                :style="{
                  backgroundColor:
                    dateRoom.status === RoomStatusEnum.BOOKING
                      ? StatusMetaMap[dateRoom.booking.status].color
                      : dateRoom.status === RoomStatusEnum.OPEN
                      ? '#F2F2F2'
                      : StatusMetaMap[dateRoom.status].color,
                  color:
                    dateRoom.status === RoomStatusEnum.BOOKING
                      ? StatusMetaMap[dateRoom.booking.status].textColor
                      : dateRoom.status === RoomStatusEnum.OPEN
                      ? '#6c6b6b80'
                      : StatusMetaMap[dateRoom.status].textColor,
                }"
                style="
                        margin:0px 6px;
                        border: solid 1px #E5E7EB;
                        "
              >
                <el-tooltip
                  :content="dateRoom.booking && dateRoom.booking.guest ? dateRoom.booking.guest.join(',') : ''"
                  placement="top"
                  :enterable="false"
                  :disabled="!(dateRoom.status === RoomStatusEnum.BOOKING && dateRoom.booking && dateRoom.booking.guest && dateRoom.booking.guest.length > 0)"
                >
                  <span v-if="dateRoom.status === RoomStatusEnum.BOOKING" class="ellipsis-text" style="cursor: pointer;" @click="onClickViewRoomOrder(dateRoom.booking.containerUuid)">
                    {{ dateRoom.booking && dateRoom.booking.guest ? dateRoom.booking.guest.join(',') : '' }}
                  </span>

                  <span v-else-if="dateRoom.status === RoomStatusEnum.RESERVE" class="ellipsis-text" style="cursor: not-allowed;">
                    {{ StatusMetaMap[dateRoom.status].label }}
                  </span>
                  <span v-else-if="dateRoom.status === RoomStatusEnum.CLOSE" class="ellipsis-text" style="cursor: not-allowed;">
                    {{ StatusMetaMap[dateRoom.status].label }}
                  </span>
                  <span v-else class="ellipsis-text" style="cursor: not-allowed;"> NT${{ formatNumber(dateRoom.priceStartAt) }} </span>
                </el-tooltip>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { BookingStatusEnum } from '../enums/bookingStatusEnum'
import { StatusMetaMap } from '../enums/statusMap'
import { RoomStatusEnum } from '../enums/roomStatusEnum'
import hotelViewOrder from './order/hotelViewOrder.vue'

export default {
  name: 'hotelViewMode',
  components: {
    FontAwesomeIcon,
    hotelViewOrder,
  },
  props: {
    roomTypeList: {
      type: Array,
      required: true,
    },
    currentProduct: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      StatusMetaMap,
      BookingStatusEnum,
      RoomStatusEnum,
      isOpenOrderForm: false,
      orderDetailed: null,
    }
  },
  methods: {
    async onClickViewRoomOrder(containerId) {
      if (!this.currentProduct.id) {
        this.$message.error('尚未選取服務地點分店')
        return
      }

      if (!containerId) {
        this.$message.error('尚未獲得訂單資料')
        return
      }

      this.$store.commit('hotel/setting/SET_PRODUCT_ID', this.currentProduct.id)
      const query = this.$route.name === 'schedule-check-in' ? { from: 'schedule-check-in' } : {}
      this.$router.push({
        name: 'hotelViewOrder',
        params: { productId: this.currentProduct.id, containerId },
        query,
      })
    },
    checkIn(data) {
      alert(data)
      console.log(data)
    },
    formatNumber(num) {
      return num?.toLocaleString() // 會自動加上千位逗號
    },
  },
}
</script>
<style scoped lang="scss">
.el-button--text {
  font-weight: 400;
  color: #ea6a2a;
}

.el-col {
  text-align: center;

  .roomType .room & {
    line-height: 65px;
  }
  .statusCalendar & {
    height: 57px;
    line-height: 20px;
  }
}

.fade-in {
  animation: fadeIn 0.8s ease forwards;
}
.fade-out {
  animation: fadeOut 0.4s ease forwards;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes fadeOut {
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-5px);
  }
}

.ellipsis-text {
  display: inline-block;
  max-width: 85px; /* 可依需求調整寬度 */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
}

::v-deep .el-button + .el-button {
  margin-left: 0px;
}
</style>
